import { passiveOption } from './passiveOption.js';

export function removeEvents(el, obj) {
  for (var prop in obj) {
    var option = ['touchstart', 'touchmove'].indexOf(prop) >= 0 ? passiveOption : false;
    el.removeEventListener(prop, obj[prop], option);
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/removeEvents.js
// module id = 857
// module chunks = 2